export default __webpack_public_path__ + "static/media/image@3x.3622af67.png";